import { ToggleButton } from '@progress/kendo-react-dateinputs';
import { DistanceBearingOutline, SupportOutline } from '../../../../../icons/icons';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setLatLngTool, setDistanceBearingTool } from '../../../../state/slices/workspace-slice';

export function MapToolsToolbarItem() {
    const dispatch = useAppDispatch();
    const latLng = useAppSelector((x) => x.workspace.mapTools.latLng);
    const distanceBearing = useAppSelector((x) => x.workspace.mapTools.distanceBearing);

    return (
        <div className="telerik-button-group" id="main-layout-map-tools">
            <ToggleButton
                id="latlng-measurement-btn"
                togglable={true}
                selected={latLng}
                data-tooltip-bottom
                svgIcon={SupportOutline}
                title="Lat/Lng"
                style={{ width: '27px', height: '27px', padding: '0px' }}
                onClick={() => dispatch(setLatLngTool(!latLng))}></ToggleButton>

            <ToggleButton
                id="distbearing-measurement-btn"
                togglable={true}
                selected={distanceBearing}
                data-tooltip-bottom
                svgIcon={DistanceBearingOutline}
                title="Distance/Bearing"
                style={{ width: '27px', height: '27px', padding: '0px' }}
                onClick={() => dispatch(setDistanceBearingTool(!distanceBearing))}></ToggleButton>
        </div>
    );
}
